import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { EyeOff, ChevronLeft } from 'lucide-react';

/**
 * Shown when an admin has hidden a page via /admin/site-pages.
 * The public API returns 404, and usePageSettings surfaces hidden=true.
 */
const HiddenPageNotice = ({ title = 'Page not available' }) => (
  <div
    className="min-h-screen flex items-center justify-center px-4 pt-20 bg-gradient-to-b from-slate-50 to-white"
    data-testid="hidden-page-notice"
  >
    <div className="max-w-md text-center">
      <div className="w-16 h-16 mx-auto rounded-full bg-amber-100 flex items-center justify-center mb-4">
        <EyeOff className="w-8 h-8 text-amber-600" />
      </div>
      <h1 className="text-2xl font-bold text-slate-900 mb-2">{title}</h1>
      <p className="text-slate-600 mb-6">
        This page is temporarily unavailable. Please check back soon.
      </p>
      <Link to="/">
        <Button className="bg-church-green hover:bg-church-green-dark">
          <ChevronLeft className="w-4 h-4 mr-1" /> Back to home
        </Button>
      </Link>
    </div>
  </div>
);

export default HiddenPageNotice;
